import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import ApiService from './../../network/ApiService';
import FirebaseImageUpload from '../../network/Firebase/storage/FirebaseImageUpload';

const SetTrainerForm = ({ teamID }) => {
    const [team, setTeam] = useState(null);
    const [coachImageURL, setCoachImageURL] = useState(null);
    const navigate = useNavigate();
    const apiServiceRef = useRef(new ApiService());

    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm({
        defaultValues: {
            coachName: '',
            coachEmail: '',
            coachImageURL: '',
        }
    });

    useEffect(() => {
        const fetchTeam = async () => {
            try {
                const response = await apiServiceRef.current.get(`/teams/${teamID}`);
                if (response) {
                    setTeam(response);
                    if (response.coach) {
                        if (response.coach.name) setValue('coachName', response.coach.name);
                        if (response.coach.email) setValue('coachEmail', response.coach.email);
                        if (response.coach.image_url) {
                            setCoachImageURL(response.coach.image_url);
                        }
                    }
                }
            } catch (error) {
                console.log('Failed to fetch team data: ' + error);
            }
        };

        if (teamID) {
            fetchTeam();
        }
    }, [teamID, setValue]);

    const onSubmit = async (data) => {
        try {
            const updatedTeam = {
                ...team,
                coach: {
                    name: data.coachName,
                    imageURL: coachImageURL,
                    email: data.coachEmail,
                }
            };

            const response = await apiServiceRef.current.patch(`/teams/${teamID}`, updatedTeam);
            if (response) {
                console.log('Trainer updated successfully!');
                navigate('/kader');
            }
        } catch (error) {
            console.log('Failed to update the trainer: ' + error);
        }
    };

    return (
        <form className={styles.formContainer} onSubmit={handleSubmit(onSubmit)}>
            {coachImageURL && (
                <div className={styles.imagePreviewContainer}>
                    <img className={styles.imagePreview} src={coachImageURL} alt="Coach" />
                </div>
            )}
            <div className={styles.row}>
                <input
                    className={classNames('field', { 'field--error': errors.coachName })}
                    type="text"
                    placeholder="Trainer Name"
                    {...register('coachName', { required: true })}
                />
            </div>
            <div className={styles.row}>
                <input
                    className={classNames('field', { 'field--error': errors.coachEmail })}
                    type="email"
                    placeholder="Trainer Email"
                    {...register('coachEmail', { required: true })}
                />
            </div>
            <div className={styles.row}>
                <FirebaseImageUpload
                    onUploadSuccess={setCoachImageURL}
                    path={`teams/${teamID}/trainer`}
                    filename="coach"
                    buttonText={"Trainer Foto auswahl"}
                />
            </div>
            <div className={styles.footer}>
                <button className="btn" type="submit">Trainer Aktualisieren</button>
                <button className="btn btn--outlined" type="reset" onClick={() => reset()}>Reset</button>
            </div>
        </form>
    );
};

SetTrainerForm.propTypes = {
    teamID: PropTypes.string.isRequired,
};

export default SetTrainerForm;
